
import { combineReducers } from "redux";

//creating an action
const UPDATE = 'update'
export function addLog(status) {
    return {
        type:UPDATE,
        status
    }
}

const defaultStatus = {status: false};
function currentStatus(state = defaultStatus, action) {
    switch (action.type) {
        case 'update':
            return action;
    
        default:
            return state;
    }
}

const loginStore = combineReducers({
    currentStatus
});

export default loginStore;